import { SVGProps, Ref, forwardRef } from 'react';

export const ImessageSolidSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path
            d="M8 1.7c-1.857 0-3.637.617-4.95 1.716C1.737 4.516 1 6.006 1 7.56a5.14 5.14 0 0 0 .911 2.884c.596.879 1.454 1.614 2.49 2.134A5.6 5.6 0 0 1 3.175 14.3a7.5 7.5 0 0 0 2.843-1.123c.643.16 1.31.242 1.98.243 1.857 0 3.638-.617 4.95-1.716 1.313-1.1 2.05-2.59 2.05-4.144s-.737-3.045-2.05-4.144S9.857 1.7 8 1.7"
            fill="currentColor"
        />
    </svg>
));
ImessageSolidSize16Glyph.displayName = 'ImessageSolidSize16Glyph';
